import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function useResponsive(query, key, start, end) {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('md'));

  return {
    isMobile: mobile,
  };
}
